import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import check from "../assets/imgTwo/checkIcon.svg";
import list from "../assets/imgTwo/listIcon.svg";
import { IoIosArrowForward } from "react-icons/io";

const ISMS = () => {
  return (
    <div className="app-wrapper">
      <Navbar />
      <div className="py-8 mt-24 flex-grow max-w-[83rem] md:mx-auto w-full">
        <div className="flex flex-col items-center justify-center text-center mb-8">
          <div className="relative flex flex-col items-center justify-center text-center md:w-[45em] h-[11em]">
            <span className="absolute left-0 top-0">
              <img src={check} alt="icon" />
            </span>
            <h2 className="text-center font-bold text-6xl my-6">ISMS Policy</h2>
            <p className="text-2xl md:mb-24">Uniswitch ISMS Policy and Objectives</p>
            <span className="absolute right-0 bottom-0">
              <img src={list} alt="icon" />
            </span>
          </div>
        </div>


        <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row md:px-5">


          <div className=" bg-[#001100] text-white rounded-xl p-8">

            <h3 className="text-3xl md:text-3xl md:leading-[3rem] font-bold text-center md:text-left md:w-[380px]">
              ISMS Policy
            </h3>
            <p>
              Safeguarding information with robust security standards ensuring<br></br> compliance, mitigating risks,
              and strengthening cyber resilience for a<br></br> secure digital environment.
            </p>


            <div className="flex justify-center md:justify-start my-6">
              <a
                href="https://uniswitch-public-assets.s3.amazonaws.com/ISMS.pdf"
                className="p-2 text-center text-[#07775D] w-[10em] inline-flex items-center justify-center gap-1"
                target="_blank"
                rel="noreferrer"
              >
                <span className="font-bold">Download Now</span>
                <IoIosArrowForward />
              </a>
            </div>
          </div>

        </div>
      </div>
      <Footer className="isms-footer" />
    </div>
  );
};

export default ISMS;
